/* cc-diy-page.js - 16 October 2026

   Three small jobs for the DIY Room page. No scroll listener, no observer
   on the window, no wheel or touchmove handler anywhere: this site has a
   recorded decision against those and they are not needed for any of this.

   1. THE WALL-CHANGES FILM. The <video> ships with NO src. It gets one only
      on a wide viewport with reduced motion off, which means a phone never
      downloads 556 KB and, more importantly, never has a video told to play
      at all. CLAUDE.md records that on an iPhone a playing video is drawn
      regardless of z-index, wrapper opacity and visibility:hidden; a video
      with no source is never in that state. preload="none" alone would not
      have done it, because autoplay overrides preload the moment the
      element is considered for playback.

   2. THE SET TILES drive the builder's own applySet() through a
      cc-setb:apply event, rather than reimplementing the layout maths a
      second time. It was a synthetic click on a chip the builder rendered,
      until those chips were removed as a duplicate on 17 Oct.

   AR used to be a third job here and is not: assets/cc-ar.js mounts
   itself wherever a slot exists, because the feature is on two pages. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------- 1. the wall changes */
  var fig = document.querySelector('[data-cc-wallchange]');
  if (fig) {
    var video = fig.querySelector('[data-wallchange-video]');
    var src = fig.getAttribute('data-video');
    var wide = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    if (video && src && wide && !reduced) {
      /* COMMIT ON `playing`, NOT ON `canplay`. The first version swapped as
         soon as the file could decode, and the preview then sat on a paused
         first frame: canplay fired, autoplay did not start, and play()
         never rejected, so nothing put the still back. A single frozen
         frame is the worst of the three outcomes available here, because
         the whole point of the block is that the SAME wall holds a
         different photograph, and one frame shows one photograph. The still
         is a two-panel comparison and makes the argument by itself.

         So nothing changes until the film is genuinely running, and if it
         is not running within WAIT it is abandoned for good.

         The swap does change the figure's shape, 1.423 to 0.750, because
         these are two different compositions. That is accepted rather than
         hidden: the script runs on load and this block sits far down the
         page, so the change happens well outside the viewport, where it
         costs no CLS and nobody sees it. A swap on scroll would have been
         the wrong trade. */
      var WAIT = 4000;
      var settled = false;
      var keepStill = function () {
        if (settled) return;
        settled = true;
        fig.removeAttribute('data-film');
        video.removeAttribute('src');
        video.load();
      };
      video.addEventListener('playing', function () {
        if (settled) return;
        settled = true;
        fig.setAttribute('data-film', 'on');
      }, { once: true });
      video.addEventListener('error', keepStill, { once: true });
      window.setTimeout(keepStill, WAIT);
      video.src = src;
      video.load();
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(keepStill);
    }
  }

  /* ------------------------------------- 1b. a set named in the address */
  /* The homepage carousel links to /pages/diy-room?start=<key>, so a slide
     opens the builder already holding that composition. Same entry point
     as a tile click, so there is one way in and one thing to keep right.
     Runs after the builder has had a chance to mount: the event is only
     useful once something is listening for it. */
  var wanted = new URLSearchParams(location.search).get('start');
  if (wanted && /^[a-z0-9-]{1,40}$/.test(wanted)) {
    var fire = function () {
      if (!document.querySelector('[data-cc-set-builder]')) return;
      document.dispatchEvent(new CustomEvent('cc-setb:apply', { detail: { key: wanted } }));
      var h = document.getElementById('cc-setb-h');
      if (h && h.scrollIntoView) h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    };
    if (document.readyState === 'complete') window.setTimeout(fire, 400);
    else window.addEventListener('load', function () { window.setTimeout(fire, 400); }, { once: true });
  }

  /* ------------------------------------------- 2a. tiles from the data */
  /* 22 Oct 2026. The row is rebuilt from assets/cc-diy-sets.json once the
     builder (which owns the rooms and the renderer) is ready. A set with
     `image: true` shows its pre-rendered tile; the rest are drawn live. With
     ?compose=1 the sets saved in this browser follow, marked "yours". Any
     failure leaves the six static tiles in the markup exactly as they were. */
  (function () {
    var sec = document.getElementById('cc-diy-sets');
    if (!sec || !sec.getAttribute('data-sets') || !window.fetch) return;
    var ul = sec.querySelector('.cc-diys__row');
    if (!ul) return;
    var base = sec.getAttribute('data-asset-base') || '';
    var compose = /[?&]compose=1(&|$)/.test(location.search);
    var tries = 0;
    function api() { return window.ccSetb; }
    function go() {
      if (!api()) { if (++tries < 40) window.setTimeout(go, 150); return; }
      Promise.all([
        fetch(sec.getAttribute('data-sets'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        api().ready,
      ]).then(function (res) {
        if (!res[1]) return;
        var sets = ((res[0] && res[0].sets) || []).slice();
        if (compose) {
          try { (JSON.parse(localStorage.getItem('cc_my_sets_v1') || '[]') || []).forEach(function (m) { m._mine = true; sets = sets.filter(function (x) { return x.id !== m.id; }); sets.push(m); }); } catch (e) {}
        }
        if (!sets.length) return;
        var frag = document.createDocumentFragment();
        var lives = [];
        sets.forEach(function (st) {
          var li = document.createElement('li'); li.className = 'cc-diys__item';
          var a = document.createElement('a'); a.className = 'cc-diys__tile'; a.href = '#cc-setb-h'; a.setAttribute('data-cc-setstart', st.id);
          var shot = document.createElement('span'); shot.className = 'cc-diys__shot';
          if (st.image && !st._mine) {
            var im = document.createElement('img');
            var f = base + 'cc-diy-set-' + st.id + '.jpg';
            im.src = f + '?width=700'; im.srcset = f + '?width=500 500w, ' + f + '?width=700 700w, ' + f + '?width=1000 1000w';
            im.sizes = '(min-width: 990px) 22vw, 70vw'; im.width = 2160; im.height = 2700; im.alt = st.alt || (st.title + ', a set of photographs hung together.'); im.loading = 'lazy'; im.decoding = 'async';
            shot.appendChild(im);
          } else {
            shot.className += ' cc-diys__shot--live';
            shot.setAttribute('role', 'img'); shot.setAttribute('aria-label', st.alt || (st.title + ', a set of photographs hung together.'));
            lives.push([shot, st]);
          }
          var lab = document.createElement('span'); lab.className = 'cc-diys__label'; lab.textContent = st.title + (st._mine ? ' (yours)' : '');
          var cnt = document.createElement('span'); cnt.className = 'cc-diys__count';
          var n = (st.prints || []).length; cnt.textContent = (n === 2 ? 'Two' : n === 3 ? 'Three' : n === 4 ? 'Four' : n === 5 ? 'Five' : n === 6 ? 'Six' : String(n)) + ' prints';
          a.appendChild(shot); a.appendChild(lab); a.appendChild(cnt); li.appendChild(a); frag.appendChild(li);
        });
        ul.innerHTML = ''; ul.appendChild(frag);
        lives.forEach(function (p) { api().renderTile(p[0], p[1]); });
      }).catch(function () {});
    }
    go();
  }());

  /* ----------------------------------------------------- 2. the set tiles */
  document.addEventListener('click', function (e) {
    var tile = e.target.closest ? e.target.closest('[data-cc-setstart]') : null;
    if (!tile) return;
    var key = tile.getAttribute('data-cc-setstart');
    /* The builder used to be reached by finding its own start chip for this
       key and clicking it. Those chips were removed on 17 Oct as the
       duplicate Charly reported, so this asks the builder directly. If the
       builder is not on the page nothing is listening, the event goes
       nowhere, and the tile's href still carries the visitor to the anchor.

       Guarded on the builder being present rather than on the event being
       handled, because a CustomEvent cannot report that. */
    if (!document.querySelector('[data-cc-set-builder]')) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('cc-setb:apply', { detail: { key: key } }));
    var h = document.getElementById('cc-setb-h');
    if (h && h.scrollIntoView) h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  /* 3. AR IS NOT WIRED HERE ANY MORE. cc-ar.js mounts itself into every
     [data-cc-ar] slot on whatever page it is loaded on, so the homepage
     band and the DIY Room page share one definition of "supported" and one
     button. This file used to create that button, which was one page's
     worth of a feature Charly asked for on two. */
}());
